import "./AboutMe.css";
import AlenaAbout from "../../Photo/AlenaAbout.jpg";
import Title from "../Title/title";

function AboutMe() {
  return (
    <div className="content" id="AboutMe">
      <div className="heading">
        <Title title="Обо мне" translate="About Me" />
      </div>

      <div className="container">
        <div className="text-a">
          {/* Заголовок с иконкой */}
          <div className="profession-header">
            <div className="profession-icon">✨</div>
            <h3 className="text-ab-h">
              Мастер-бровист и специалист по красоте
            </h3>
          </div>

          <p className="text-ab-p">
            Меня зовут <strong>Алёна Трошина</strong>, и я с гордостью
            представляю себя как мастер брови, с десятилетним стажем,
            специалиста по ламинированию ресниц и перманентному макияжу.
          </p>

          <div className="highlight-quote">
            <p className="quote-text">
              Моя работа — это не просто профессия, а настоящее призвание,
              которое позволяет мне помогать людям чувствовать себя красивыми и
              уверенными в себе.
            </p>
          </div>

          {/* Блок с опытом */}
          <div className="experience-cards">
            <div className="experience-card">
              <span className="experience-years">10+</span>
              <span className="experience-label">Лет в бьюти-индустрии</span>
            </div>
            <div className="experience-card">
              <span className="experience-years">1000+</span>
              <span className="experience-label">Довольных клиентов</span>
            </div>
            <div className="experience-card">
              <span className="experience-years">50+</span>
              <span className="experience-label">Образовательных курсов</span>
            </div>
          </div>

          <h4 className="text-ab-h" style={{ marginTop: "40px" }}>
            Путь в индустрию красоты
          </h4>
          <p className="text-ab-p">
            Мой путь в мир красоты начался с увлечения эстетикой и желанием
            создать гармоничный образ. Я прошла множество школ, курсов и
            тренингов, чтобы освоить различные техники и методы работы, и с
            каждым годом моя страсть к этому делу только усиливалась.
          </p>

          {/* Список преимуществ */}
          <div className="advantages-list">
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-text">
                Постоянно обучаюсь новым техникам
              </div>
            </div>
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-text">
                Использую только профессиональные материалы
              </div>
            </div>
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-text">
                Индивидуальный подход к каждому клиенту
              </div>
            </div>
          </div>

          <p className="text-ab-p" style={{ marginTop: "20px" }}>
            Я постоянно совершенствую свои навыки, чтобы предложить своим
            клиентам только самое лучшее и актуальное в мире красоты.
          </p>
        </div>

        <div className="image">
          <div className="image-decoration"></div>
          <img
            className="alena"
            src={AlenaAbout}
            alt="Алена Трошина - профессиональный мастер бьюти-индустрии"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
